import classNames from "classnames";
import React from "react";
import { phpBool } from "../../../core/Helpers";
import { Icon } from "../../../core/Icon";
import { Link } from "react-router-dom";
export const EnrollmentProgress = (props) => {
    const { enrollment } = props;
    return React.createElement(React.Fragment, null, enrollment && enrollment.id &&
        React.createElement(React.Fragment, null, enrollment.confirmed > 0 ?
            React.createElement("div", { className: "well" },
                React.createElement("b", null,
                    "Pro \u00FA\u010Dast v aukci v\u00E1m bylo p\u0159id\u011Bleno \u010D. ",
                    enrollment.id))
            :
                React.createElement("div", { className: "ed-enrollment" },
                    React.createElement("div", { className: "flex-space mb-12" },
                        React.createElement("h2", { className: "h4 mb-0 mr-12" }, "Podm\u00EDnky pro \u00FA\u010Dast"),
                        React.createElement(Link, { className: "hyperlink", to: "/cs/seznam/podminky-ucasti" }, "Pot\u0159ebuji poradit se spln\u011Bn\u00EDm podm\u00EDnek")),
                    React.createElement("div", { className: "ed-sign" },
                        React.createElement("div", { className: classNames("cond ass", { "done": phpBool(enrollment.assurance) }) },
                            React.createElement("span", { "aria-hidden": true, className: "status" },
                                React.createElement(Icon, { c: ['tick', 10, 10] })),
                            React.createElement("span", { className: "number" }, "1"),
                            React.createElement("span", { className: "text" },
                                "Slo\u017Eit jistotu: ",
                                phpBool(enrollment.assurance) ? 'Splněno' : 'Nesplněno')),
                        React.createElement("div", { className: classNames("cond aft", { "done": phpBool(enrollment.affidavit) }) },
                            React.createElement("span", { "aria-hidden": true, className: "status" },
                                React.createElement(Icon, { c: ['tick', 10, 10] })),
                            React.createElement("span", { className: "number" }, "2"),
                            React.createElement("span", { className: "text" },
                                "Doru\u010Dit smlouvu: ",
                                phpBool(enrollment.affidavit) ? 'Splněno' : 'Nesplněno')),
                        React.createElement("div", { className: classNames("cond conf", { "done": enrollment.confirmed > 0 }) },
                            React.createElement("span", { "aria-hidden": true, className: "status" },
                                React.createElement(Icon, { c: ['tick', 10, 10] })),
                            React.createElement("span", { className: "number" }, "3"),
                            React.createElement("span", { className: "text" }, "Potvrzen\u00ED administr\u00E1torem: \u010Cek\u00E1"))))));
};
